/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Informacja o przetwarzaniu danych osobowych') {
            document.title = 'Informacja o przetwarzaniu danych osobowych';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</b></Typography><br />
                <br />
                <Typography variant='body2' gutterBottom>Zgodnie z art.13 ust.1 i ust.2 rozporządzenia Parlamentu Europejskiego i rady (UE) 2016/679 z dnia 27 kwietnia 2016r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólnego rozporządzenia o ochronie danych), informujemy, że: </Typography>
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Administratorem Państwa danych osobowych jest „EUROMID” Spółka z ograniczoną odpowiedzialnością z siedzibą w Rzeszowie, ul. Mickiewicza 5, 35-064 Rzeszów, 
                    NIP: 8133282177, REGON: 691682062, KRS: 0000123492, prowadząca działalność hotelarską pod nazwą Hotel Hubertus Rzeszów, tel.<a href={`tel:${'+48600929015'}`} className={`${classes.email}`}>{'+48 600 929 015'}</a>, strona internetowa: <a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hubertus.rzeszow.pl
                        </Button>
                    </a>; adres poczty elektronicznej: <a href={`mailto:${'recepcja@hubertus.rzeszow.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@hubertus.rzeszow.pl'}</a> </Typography></li>
                    <Typography variant='body2' gutterBottom>Administrator nie wyznaczył inspektora ochrony danych osobowych; </Typography>
                    <li><Typography variant='body2' gutterBottom>Państwa dane pozyskaliśmy:
                        <ul>
                            <li>bezpośrednio od Państwa; </li>
                            <li>ze źródeł publicznych oraz ogólnodostępnych, w tym z Internetu, np. Krajowego Rejestru Sądowego, Centralnej Ewidencji i Informacji o Działalności Gospodarczej. </li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>„EUROMID” Spółka z ograniczoną odpowiedzialnością przetwarza następujące kategorie danych:
                        <ul>
                            <li>dane kontaktowe; </li>
                            <li>dane wymagane do identyfikacji na potrzeby zawarcia umowy, wykonania usługi, wystawienia faktury, obsługi posprzedażowej, numery kont w celu rozliczeń między firmą Green Spółka Cywlna a Klientem;</li>
                            <li>dane identyfikacyjne niezbędne do świadczenia usług on-line; </li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom> Cele i podstawa prawna przetwarzania danych<br></br>Państwa dane osobowe będą przetwarzane na podstawie:
                        <ul>
                            <li>art. 6 ust. 1 lit. b RODO – w zakresie jakim jest to konieczne w celu realizacji łączącej nas umowy,</li>
                            <li>art. 6 ust. 1 lit. c RODO – w zakresie niezbędnym do realizacji obowiązków prawnych ciążących na Administratorze, takich jak rozliczenia finansowe, w tym podatkowe,</li>
                            <li>art. 6 ust. 1 lit. f RODO – w zakresie niezbędnym do realizacji celów wynikających z prawnie uzasadnionych interesów Administratora, w tym ewentualnej konieczności dochodzenia lub obrony przed roszczeniami cywilnoprawnymi.</li>
                        </ul></Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Podane dane nie będą przekazywane do państwa trzeciego ani organizacji międzynarodowej; </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Odbiorcami Państwa danych mogą być podmioty upoważnione na podstawie przepisów prawa oraz podmioty świadczące na rzecz Administratora usługi na podstawie zawartych umów powierzenia przetwarzania danych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Państwa dane będą przechowywane przez okres trwania umowy oraz po jej zakończeniu przez czas wymagany przepisami prawa, w szczególności przepisami podatkowymi i rachunkowymi, a także do czasu przedawnienia ewentualnych roszczeń.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Podając swoje dane osobowe, mają Państwo prawo do:
                    <ul>
                            <li>wniesienia sprzeciwu wobec przetwarzania danych,</li>
                            <li>przenoszenia danych,</li>
                            <li>cofnięcia zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej cofnięciem.</li>
                        </ul></Typography></li>
                    <li>
                        <Typography variant='body2' gutterBottom style={{marginBottom: "15px"}}>Przysługuje Państwu prawo wniesienia skargi do organu nadzorczego, którym jest:</Typography>
                        <Typography variant='body2' gutterBottom>Prezes Urzędu Ochrony Danych Osobowych</Typography>
                        <Typography variant='body2' gutterBottom>ul. Stawki 2</Typography>
                        <Typography variant='body2' gutterBottom style={{marginBottom: "15px"}}>00-193 Warszawa</Typography>
                    </li>
                    <li><Typography variant='body2' gutterBottom>Podanie danych osobowych jest dobrowolne, jednak ich niepodanie może uniemożliwić zawarcie umowy lub realizację usługi.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Nie przewidujemy zautomatyzowanego przetwarzania danych osobowych, w tym profilowania.</Typography></li> 
                </ol>
                {/* <ol type="1">
                    <br />
                    <Typography variant='body1' align="center"><b>Polityka Cookies „Ciasteczka”</b></Typography><br />
                    <li><Typography variant='body2' gutterBottom>Cookies są przekazywane do przeglądarek internetowych i następnie są przechowywane w pamięci urządzeń i odczytywane przez serwer przy każdorazowym połączeniu ze Stroną Internetową.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zaznaczamy, że zapis cookies nie umożliwia Nam dostępu do Twojego prywatnego urządzenia ani odczytywania innych danych niż zapisane w cookies.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Korzystamy z tzw. cookies technicznych, które umożliwiają prawidłowe wykorzystywanie transmisji komunikatu oraz zapamiętywanie Twoich ustawień i do tworzenia prostych statystyk Serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Korzystamy z cookies i technologii do zbierania danych, które pomagają nam analizować ruch na Stronie Internetowej. Dzięki temu możemy optymalizować jej działanie, udoskonalać rozwiązania, które cieszą się największym zainteresowaniem oraz wyświetlać dedykowane wiadomości i oferty. Możesz wyrazić zgodę, nie wyrazić zgody, cofnąć ją lub zarządzać ustawieniami.</Typography></li>
                </ol> */}
                {/* <br /> */}
                <div id="footer">
                    <Typography variant='body2' gutterBottom>
                        {/* <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-wynajem" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Warunki wynajmu
                            </Button>
                        </a>
                              
                        <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-pobyt" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Regulamin pobytu
                            </Button>
                        </a>
                              
                        <a href="https://vsc24.net/vscZasady/zasady/Regulamin/zary-HAYDUK-pobyt" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Informacja o przetwarzaniu danych osobowych
                            </Button>
                        </a>
                               */}
                        {/* <a href="https://hayduk.pl/polityka-prywatnosci/" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                Polityka prywatności
                            </Button>
                        </a> */}
                              
                    </Typography>
                </div>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
